  import { ApiListResponse, ApiResponse } from "@/types/api-response.model";
  import { AttendanceData, AttendanceExportFilter, AttendanceFilter, AttendanceTodayData, CreateAttendanceDto } from "@/types/attendance.interfaces";
  import { HttpClient, HttpParams } from "@angular/common/http";
  import { inject, Injectable } from "@angular/core";
  import { Observable } from "rxjs";

  @Injectable({ providedIn: 'root' })
  export class AttendanceService {
    private http = inject(HttpClient);
    private readonly apiUrl = `/api/attendance`;

    getAllAttendance(filters?: AttendanceFilter): Observable<ApiListResponse<AttendanceData>> {
      let params = new HttpParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            params = params.set(key, value.toString());
          }
        });
      }

      return this.http.get<ApiListResponse<AttendanceData>>(this.apiUrl, { params });
    }

    getTodayStatus(): Observable<ApiResponse<AttendanceTodayData>> {
      return this.http.get<ApiResponse<AttendanceTodayData>>(`${this.apiUrl}/today`);
    }

    manualCheckin(data: FormData): Observable<ApiResponse<AttendanceData>> {
      return this.http.post<ApiResponse<AttendanceData>>(`${this.apiUrl}/checkin/manual`, data);
    }

    manualCheckout(data: FormData): Observable<ApiResponse<AttendanceData>> {
      return this.http.post<ApiResponse<AttendanceData>>(`${this.apiUrl}/checkout/manual`, data);
    }

    getDetailById(id: string): Observable<ApiResponse<AttendanceData>> {
      return this.http.get<ApiResponse<AttendanceData>>(`${this.apiUrl}/${id}`);
    }

    updateAttendanceStatus(
      id: string,
      status?: string,
      adminId?: string,
      note?: string
    ): Observable<ApiResponse<AttendanceData>> {
      const body: Record<string, any> = {};

      if (status !== undefined) {
        body['status'] = status;
      }
      if (adminId) {
        body['manualBy'] = adminId;
      }
      if (note !== undefined) {
        // Mengirim kedua alternatif key agar aman sesuai kontrak DTO backend
        body['manualReason'] = note;
        body['note'] = note;
      }

      return this.http.patch<ApiResponse<AttendanceData>>(`${this.apiUrl}/${id}`, body);
    }


    //export excel
    exportExcel(filters: AttendanceExportFilter): Observable<Blob> {
    let params = new HttpParams()
      .set('startDate', filters.startDate)
      .set('endDate', filters.endDate)
      .set('sortBy', filters.sortBy ?? 'date')
      .set('sortOrder', filters.sortOrder ?? 'DESC');

    if (filters.status) {
      params = params.set('status', filters.status);
    }

    if (filters.employeeId) {
      params = params.set('employeeId', filters.employeeId);
    }

    return this.http.get(`${this.apiUrl}/export/excel`, {
      params,
      responseType: 'blob',
    });
  }


  }
